import React from "react";
import { LinkOutlined as SSOEnabledCheck } from '@ant-design/icons';
import { Tooltip } from '@servahealth/serva-ui-kit';

interface SSOEnabledCheckIconProps {
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
  tooltipText?: string;
}

const SSOEnabledCheckIcon: React.FC<SSOEnabledCheckIconProps> = ({
  onClick,
  className,
  style,
  tooltipText,
}) => {
  return (
    <Tooltip title={tooltipText}>
      <SSOEnabledCheck onClick={onClick} className={className} style={style} />
    </Tooltip>
  );
};

export default SSOEnabledCheckIcon;
